import { useState } from 'react';
import SearchRegionsDropdownList from './SearchRegionsDropdownList';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';

const RegionDropdownMultiselectOpenList = ({
  onChoose,
  items,
  value,
  subvalue,
  depth,
}) => {
  const setSubregion = (e, id, subid) => {
    e.stopPropagation();
    onChoose(id, subid);
  };
  const [openGroup, setOpenGroup] = useState(null);

  const handleGroupToggle = (groupName) => {
    setOpenGroup((prevOpenGroup) =>
      prevOpenGroup === groupName ? null : groupName
    );
  };

  return (
    <div className="dropdown-open">
      {items.length && (
        <div className="popup-body fixed">
          <div className="popup-body__items">
            {items.map((item) => {
              if (item.children) {
                const { children, group, id } = item;

                let isAnyItemChosen = children.some((child) =>
                  value.includes(child.id)
                );

                let isAnySubItemChosen = children.some(
                  (child) =>
                    child.subitems &&
                    child.subitems.some((subitem) =>
                      subvalue.includes(subitem.id)
                    )
                );

                const isChosen = isAnyItemChosen || isAnySubItemChosen;
                return (
                  <div className="group" key={id}>
                    <div
                      className={`group__title group__title_grand ${
                        isChosen ? 'group__title_chosen' : ''
                      }`}
                      onClick={() => handleGroupToggle(group)}
                    >
                      {group}
                      <button>
                        {openGroup === group ? (
                          <AiOutlineMinusCircle color="#fb089b" />
                        ) : (
                          <AiOutlinePlusCircle />
                        )}
                      </button>
                    </div>
                    <div
                      className={`group__items ${
                        openGroup === group ? 'group__items_opened' : ''
                      }`}
                    >
                      {children.map((child) => {
                        return (
                          <div
                            className="group"
                            key={child.id}
                            onClick={() => onChoose(child.id)}
                          >
                            <SearchRegionsDropdownList
                              value={value}
                              subvalue={subvalue}
                              onChoose={onChoose}
                              item={child}
                              titleCss={' group__title_subcolor'}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div
                    className="group"
                    key={item.id}
                    onClick={() => onChoose(item.id)}
                  >
                    <SearchRegionsDropdownList
                      value={value}
                      subvalue={subvalue}
                      onChoose={onChoose}
                      item={item}
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionDropdownMultiselectOpenList;
